<template lang="pug">
  div
    SideNav(:mini="mini")
    v-app-bar(
      app,
      hide-on-scroll,
      light,
      color='transparent',
      :elevation="0",
    )
      v-app-bar-nav-icon
        template(name="default")
          v-btn.mx-2(
            fab, light, small,
            color='white'
            @click="mini = !mini"
          )
            v-icon(dark small) {{ mini? 'fas fa-list-alt' : 'fas fa-bars' }}
      v-toolbar-title {{ $t(`title.${$route.name}`) }}
      v-spacer
      v-chip.mr-2(
        v-if="authUser.first_name",
        outlined,
        color="primary",
      )
        v-icon(left, small) fas fa-user-circle
        | Logged in as {{ authUser.first_name }} {{ authUser.last_name }}
    v-main
      v-container.fill-height.pa-5(fluid)
        v-overlay(
          v-if="isLoading",
          :value="isLoading",
        )
          v-progress-circular(:value="20" indeterminate)
        slot
</template>

<script>
import { mapGetters } from 'vuex';
import { roleManager } from '@/config/mixins.js';

import SideNav from '@/components/elements/SideNav.vue';

export default {
  components: {
    SideNav,
  },

  mixins: [roleManager],

  computed: {
    ...mapGetters({
      authUser: 'auth/auth',
    }),
  },

  created() {
    window.$eventHub.$on('toggleLoader', this.toggleLoader);
  },

  beforeDestroy() {
    window.$eventHub.$off('toggleLoader');
  },

  data() {
    return {
      mini: true,
      isLoading: false,
    };
  },

  methods: {
    toggleLoader({ state }) {
      this.isLoading = state;
    },
  },
};
</script>
